import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectStore(data) {
  return request({
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded",
    // },
    url: `/admin/plus/store/select`,
    method: "POST",
    data,
  });
}

export function updateStore(data) {
  return request({
    url: `/admin/plus/store/update`,
    method: "POST",
    data,
  });
}

export function deleteStore(data) {
  return request({
    url: `/admin/plus/store/delete`,
    method: "POST",
    data,
  });
}